import { notifications } from '@mantine/notifications';

/**
 * Show success notification
 * @param message Message to display
 */
export const showSuccess = (message: string) => {
  notifications.show({
    title: 'Success',
    message,
    color: 'green',
    autoClose: 3000,
  });
};

/**
 * Show error notification
 * @param message Message to display
 */
export const showError = (message: string) => {
  notifications.show({
    title: 'Error',
    message,
    color: 'red',
    autoClose: 3000,
  });
};

/**
 * Show warning notification
 * @param message Message to display
 */
export const showWarning = (message: string) => {
  notifications.show({
    title: 'Warning',
    message,
    color: 'yellow',
    autoClose: 3000,
  });
}; 